import {SESSIONSTORAGE_KEYS} from './constants/storages'

export const suppressMarketingReminderForSession = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.sessionStorage.setItem(SESSIONSTORAGE_KEYS.MARKETING_REMINDER_SUPPRESSED, 'true')
}

export const isMarketingReminderSuppressedForSession = () => {
  if (typeof window === 'undefined') {
    return false
  }

  return window.sessionStorage.getItem(SESSIONSTORAGE_KEYS.MARKETING_REMINDER_SUPPRESSED) === 'true'
}
